import { Injectable } from '@angular/core'
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { ActiveCartFacade, CartAddEntrySuccessEvent } from '@spartacus/cart/base/root'
import { EventService } from '@spartacus/core'
import { first, map, take } from 'rxjs/operators'
import {
  MbAddedToCartDialogComponent
} from '../../cart/components/mb-add-to-cart/mb-added-to-cart-dialog/mb-added-to-cart-dialog.component'
import { MbModalService } from './modal.service'
import { Store } from '@ngrx/store'
import { MbStateWithAnalyticsContext } from '../../analytics/store/state'
import { MbAnalyticsActions } from '../../analytics/store/actions'
import { DataAnalyticsClickSource, DataAnalyticsEventLabel } from '../mb-constants'
import { MbAnalyticsSelectors } from '../../analytics/store/selectors'

@Injectable({
  providedIn: 'root'
})
export class MbAddToCartService {
  modalRef: NgbModalRef | undefined = undefined
  numberOfEntriesBeforeAdd = 0

  constructor (protected store: Store<MbStateWithAnalyticsContext>,
               protected activeCartService: ActiveCartFacade,
               protected eventService: EventService,
               protected modalService: MbModalService) {
  }

  addToCart ({ productCode, quantity, source, eventLabel }: {
    productCode: string;
    quantity?: number;
    source?: DataAnalyticsClickSource;
    eventLabel?: DataAnalyticsEventLabel;
  }) {
    if (!productCode) {
      return
    }

    this.store.dispatch(MbAnalyticsActions.addToCart({
      addToCartSource: source,
      eventLabel: eventLabel
    }))

    this.eventService.get(CartAddEntrySuccessEvent).pipe(
      first(),
      map(cartEvent => cartEvent?.quantity !== cartEvent?.quantityAdded || false),
    ).subscribe(isCartAdjusted => {
      this.modalService.closeActiveModal()
      this.modalRef = this.modalService.open(MbAddedToCartDialogComponent, {
        centered: true,
        size: 'lg',
        windowClass: 'add-to-cart-ng-modal'
      })
      const { componentInstance } = this.modalRef
      componentInstance.entry$ = this.activeCartService.getLastEntry(productCode || '')
      componentInstance.cart$ = this.activeCartService.getActive()
      componentInstance.loaded$ = this.activeCartService.isStable()
      componentInstance.quantity = quantity
      componentInstance.numberOfEntriesBeforeAdd = this.numberOfEntriesBeforeAdd
      componentInstance.isCartAdjusted = isCartAdjusted
    })

    this.activeCartService
      .getEntries()
      .pipe(take(1))
      .subscribe((cartEntries) => {
        this.numberOfEntriesBeforeAdd = cartEntries.length
        if (productCode) {
          this.activeCartService.addEntry(
            productCode,
            quantity || 1
          )
        }
      })
  }

  getMostRecentAddToCartClickSource () {
    return this.store.select(MbAnalyticsSelectors.getMostRecentAddToCartSource)
  }

  getMostRecentAddToCartEventLabel () {
    return this.store.select(MbAnalyticsSelectors.getMostRecentAddToEventLabel)
  }

  resetCartAnalytics () {
    this.store.dispatch(MbAnalyticsActions.resetCart())
  }
}
